
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rugs/[slug]",
      function () {
        return require("private-next-pages/rugs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rugs/[slug]"])
      });
    }
  